import { EVENT_TYPES } from './event-types'

export default {
  CANCEL_ORDER_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'cancel__order_exit_button_clicked',
  },
  CANCEL_ORDER_POPUP_SHOWN: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'cancel__cancellation_popup_viewed',
  },
  CANCEL_ORDER_POPUP_CLOSED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'cancel__cancellation_popup_close_clicked',
  },
  CANCEL_ORDER_POPUP_CONTINUE_WITH_TAMARA_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'cancel__cancellation_popup_continue_with_tamara_clicked',
  },
  CANCEL_ORDER_POPUP_BACK_TO_MERCHANT_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'cancel__cancellation_popup_back_to_merchant_clicked',
  },
  CANCEL_CANCELLATION_REASON_RADIO_CLICKED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'cancel__order_exit_survey_reason_clicked',
  },

  CANCEL_CANCELLATION_REASON_INPUT_INTERACTED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'cancel__order_exit_survey_reason_detail_input_box_interacted',
  },
  ORDER_CANCELED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'cancel__order_succesfully_cancelled',
  },
  ORDER_NOT_FOUND_ERROR: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'checkout__order_not_found',
  },
  CHECKOUT_PAGE_HIDDEN: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'customer__left_checkout',
  },
  CHECKOUT_PAGE_VISIBLE: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'customer__back_to_checkout',
  },
  GET_SESSION_API_CALLED: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'load__get_checkout_session_api_called',
  },
  INVALID_CHECKOUT_SESSION: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'load__get_checkout_session_api_response_invalid_session',
  },
  FETCH_CHECKOUT_CONFIGURATION: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'load__fetch_checkout_configuration_api_called',
  },
  NEW_RELIC_INITIALIZATION_ERROR: {
    EVENT_TYPE: EVENT_TYPES.TRACK,
    EVENT_NAME: 'load__initializing_new_relic_failed',
  },
  VPN_DETECTED_PAGE_VIEWED: {
    EVENT_TYPE: EVENT_TYPES.PAGE,
    EVENT_NAME: 'vpn_detected__page_viewed',
  },
}
